import React, { useCallback } from 'react';
import { RadioGroup as MuiRadioGroup } from '@material-ui/core';
/**
 * ラジオボタングループコンポーネント。
 */
export var RadioButtonGroup = function (props) {
    var className = props.className, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, children = props.children, direction = props.direction;
    var handleChange = useCallback(function (event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
    }, [onChange]);
    // MuiRadioGroupのrowは1行に「表示するかどうか」なのでflex-directionとは逆の指定となる。
    var isRow = direction === 'column';
    return (React.createElement(MuiRadioGroup, { className: className, value: value, defaultValue: defaultValue, onChange: handleChange, row: isRow }, children));
};
